import { Component, OnInit } from '@angular/core';
import { Http, Response } from '@angular/http';

import { AutenticaService } from '../autentica.service';
import { ConfigsService } from './../../configs.service';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
declare var swal;


@Component({
  selector: 'app-novo-acesso',
  templateUrl: './novo-acesso.component.html',
  styleUrls: ['./novo-acesso.component.css']
})
export class NovoAcessoComponent implements OnInit {

  logo:string;
  corPadrao:string;
  dataAtual:any = new Date();
  anoAtual:any = this.dataAtual.getFullYear();  

  constructor(private app: ConfigsService, 
              private autentica: AutenticaService, 
              private config: ConfigsService,
              private rota: Router,
              private titulo: Title,
              private http:Http) {

    this.titulo.setTitle("Novo Acesso - "+this.config.nome);
    this.logo = app.logo;
    this.corPadrao = app.corPadrao;    
  }

  listaEstados:any = ["AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RO", "RS", "RR", "SC", "SE", "SP", "TO"]
 
  listaConselhos:any = []
  trazConselhos(){
    this.http.post(`${this.config.urlApi}/medicos/conselhos`, [])
      .subscribe(data => {        
        var dados = data.json();
        // console.log(dados);
        this.listaConselhos = dados.dados;
    });
  }
  

  validaCadastro(form){

    this.http.post(`${this.config.urlApi}/medicos/novo`, form.value)
      .subscribe(data => {
        
        var dados = data.json();

        if(dados.status == 1){
          swal("Sucesso!", "Sua senha foi atualizada com sucesso!", "success")
            .then(d => {
              this.rota.navigate(["/login"]);
            });
        }else if(dados.status == -1){
          swal("Oops!", "Senha já cadastrada em nosso banco de dados.", "info")
          .then(d => {
            this.rota.navigate(["/login"]);
          });
        }else if(dados.status == -2){
          swal("Oops!", "Email já cadastrado em nosso banco de dados.", "info")
          .then(d => {
            this.rota.navigate(["/login"]);
          });
        }else if(dados.status == -3){
          swal("Oops!", "A confirmação da senha não coincide.", "info");
        }else{
          swal("Oops!", "Dados incorretos. <br>Se o erro persistir, contate o administrador.", "warning");
        }
      });
    // console.log(dados);
  }
  
  ngOnInit(){    
    this.trazConselhos()
  }

}



// WEBPACK FOOTER //
// ./src/app/login/novo-acesso/novo-acesso.component.ts